import { useSuspenseQuery } from "@tanstack/react-query";

import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "#/components/ui/card";
import { Skeleton } from "#/components/ui/skeleton";
import { myEntitlementsQueryOptions, playerProfileQueryOptions } from "#/lib/queries";
import {
  hasSubscriptionCardFooter,
  SubscriptionCardFooter,
  SubscriptionCardStatus,
} from "#/routes/-profile.subscriptionCardBody";

function SubscriptionCardHeader() {
  return (
    <CardHeader>
      <CardTitle>Subscription</CardTitle>
      <CardDescription>Details of your subscription.</CardDescription>
    </CardHeader>
  );
}

export function SubscriptionCardSkeleton() {
  return (
    <Card>
      <SubscriptionCardHeader />
      <CardContent>
        <Skeleton className="h-5 w-72" />
      </CardContent>
      <CardFooter>
        <Skeleton className="h-7 w-28" />
      </CardFooter>
    </Card>
  );
}

export function SubscriptionCard({ userId }: { userId: string }) {
  const { data: profile } = useSuspenseQuery(playerProfileQueryOptions(userId));
  const { data: entitlements } = useSuspenseQuery(myEntitlementsQueryOptions(userId));
  const loaded = { profile, entitlements };

  return (
    <Card>
      <SubscriptionCardHeader />
      <CardContent>
        <SubscriptionCardStatus profile={loaded.profile} entitlements={loaded.entitlements} />
      </CardContent>
      {hasSubscriptionCardFooter(loaded) ? (
        <CardFooter>
          <SubscriptionCardFooter profile={loaded.profile} entitlements={loaded.entitlements} />
        </CardFooter>
      ) : null}
    </Card>
  );
}
